import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';
import * as Highcharts from 'src/assets/js/highcharts';

@Component({
  selector: 'g10-emp-app-installation-report',
  templateUrl: './emp-app-installation-report.component.html',
  styleUrls: ['./emp-app-installation-report.component.css']
})
export class EmpAppInstallationReportComponent implements OnInit {

  public matFormSize = '12px';
  public filterForm: FormGroup;

  public noDataFoundEnable: boolean = false;
  public excelData = {};
  public exlNoDataFound = false;


  public maxDate = new Date();
  public maxEndDate = new Date();

  public localStorage;
  public errorObject: any = {
    startDate: '',
    endDate: '',
  }
  public formSubmitted: boolean = false;

  public empAppData = [];


  public showTable: boolean = true;
  public tableData: any = [];
  public cols: any = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Employee name' ,headerConfig:{ isDefault: true} },
    {
      key: 'empRefID', display: 'Employee ID',
      config: {
        isUppercase: true,
      },
      headerConfig:{ isDefault: true}
    },
    {
      key: 'email', display: 'Email',
      config: {
        isLowercase: true,
      }
    },
    // { key: 'lastLogin', display: 'Last Login' },
    {
      key: 'lastLoginTime', display: 'Last login time', config: {
        isDate: true,
        format: 'dd/MM/YYYY HH:mm:ss'
      },
      headerConfig:{ isDefault: true}
    },
  ];

  /* Excel */
  public empAppExlData: any = [];
  public branchData = {};
  public shiftData = {};
  public showDownloadBtn: boolean = true;
  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 25,
    totalPage: 1,
  };
  public filterData = {};

  constructor(
    private api: ApiService,
    private storage: StorageService,
    private fb: FormBuilder,
    private com: CommonServices,
    private excel: ExcelExportService,
  ) {
    this.filterFormLoad();
  }

  ngOnInit(): void {
    let obj = {
      startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
      endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
    }
    this.getEmpAppExlReport(obj);
    this.getEmpAppReports(1, this.paginationData.limit, obj);
  }

  filterFormLoad() {
    this.filterForm = this.fb.group({
      search: new FormControl(''),
      startDate: new FormControl(new Date(), [Validators.required]),
      endDate: new FormControl(new Date(), [Validators.required]),
    });
  }

  dateFromAction(obj: any = {}, type) {
    obj.selectedDates.map((x: any) => {
      this.filterForm.controls[type].patchValue(x.getTime());
    });
  }

  setMaxDate() {
    let t_maxDate = new Date(this.filterForm.controls.startDate.value);

    //add a day to the date
    t_maxDate.setDate(t_maxDate.getDate() + 30);

    if (new Date() > t_maxDate) {
      this.maxEndDate = t_maxDate;
    } else {
      this.maxEndDate = new Date();
    }
  }

  validation(data) {
    let objectKeys = Object.keys(this.errorObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (data[key] == '' || data[key] == undefined || data[key] == null || Number.isNaN(data[key]) || data.length <= 0) {
        this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      } else if ((key == 'startDate' || key == 'endDate')) {
        if (new Date(data.startDate).getTime() > new Date(data.endDate).getTime()) {
          isValid = false;
          this.errorObject['endDate'] = 'Invalid end date';
        }else if(new Date(this.maxEndDate).getTime() < new Date(data.endDate).getTime()){
          isValid = false;
          this.errorObject['endDate'] = "Maximum 30 days can be select"
        }
      }
    }
    return isValid;
  }

  checkValidation() {
    let obj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    if (this.formSubmitted) this.validation(obj);
  }

  onSubmit() {
    // console.log(this.sosForm.value);
    this.formSubmitted = true;
    let checkObj = {
      startDate: new Date(this.filterForm.value.startDate).getTime(),
      endDate: new Date(this.filterForm.value.endDate).getTime(),
    }
    let isValid = this.validation(checkObj);
    if (isValid) {
      let obj = {
        startDate: new Date(new Date(this.filterForm.value.startDate).setHours(0)).getTime(),
        endDate: new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59)).getTime(),
      }
      if (this.filterForm.value.search != '') obj['search'] = this.filterForm.value.search;
      this.getEmpAppExlReport(obj);
      this.getEmpAppReports(1, this.paginationData.limit, obj);
    }
  }


  getEmpAppReports(page: number = 1, limit = 25, filter = null) {
    let obj = { page, limit };
    if (filter) {
      obj = { ...obj, ...filter };
      this.filterData = { ...filter};
    }
    this.api.transportManagerEmpAppReports(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.empAppData = res['data'];
          if(res.branch && Object.keys(res.branch).length > 0 ) this.branchData = { ...this.branchData,...res.branch};
          if(res.shift && Object.keys(res.shift).length > 0 ) this.shiftData = { ...this.shiftData,...res.shift };
          this.tableData = res['data'];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
        this.processPagination(res, obj);
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log('err', err);
    })

  }

  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getEmpAppReports(data.page, data.limit, filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
  }


  async getEmpAppExlReport(obj) {
    this.empAppExlData = [];
    let results: any = await this.api.transportManagerEmpAppExlReports(obj).catch((e) => { 
      this.exlNoDataFound = true;
      console.log('Data retriving issues') 
    });

    if (results && results['status'] == 'success') {
      if (results['data'].length > 0) {
        this.empAppExlData.push(...results['data']);
        this.branchData = { ...this.branchData,...results.branch};
        this.shiftData = { ...this.shiftData,...results.shift };
        this.exlNoDataFound  = false;
      }else {
        this.exlNoDataFound = true;
      }
    }else {
      this.exlNoDataFound = true;
    }
    
  }



  async exportToExcel() {
    let data = [];
    const startDate = new Date(this.filterForm.value.startDate + '');
    const endDate = new Date(new Date(this.filterForm.value.endDate + '').setHours(23, 59, 59));
    let exlData = {};
    this.empAppExlData.map((item)=>{ exlData[item.empRefID] = item; });
    this.empAppExlData = Object.values(exlData).sort((a,b)=> b['lastLoginTime'] - a['lastLoginTime']);
    for (let i = 0; i < this.empAppExlData.length; i++) {
      let item = this.empAppExlData[i];
      try {
        console.log(item);
        let res = {
          value: [
            i + 1,
            item.name ? this.com.convertTitleCase(item.name) : '---',
            item.empRefID ? String(item.empRefID).toUpperCase() : '---',
            item.email ? item.email : '---',
            item.branch ? this.com.convertTitleCase(this.branchData[item.branch]) : '---',
            item.shift ? this.com.convertTitleCase(this.shiftData[item.shift]) : '---',
            item.workLocation ? this.com.convertTitleCase(item.workLocation) : '---',
            item.lastLoginTime ? this.com.timestampToDate(item.lastLoginTime, 'DMY H:M:S') : '---',
          ],
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }


    if (data.length > 0) {

      let rowCount = 2;
      let endCell = 'H';
      let customizedData = [];
      let titleRow = {
        value: ['Employee App Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },

        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: '966462AF' }
        },
      }

      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Start Date       : " + this.com.timestampToDate(new Date(startDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.com.timestampToDate(new Date(endDate).getTime(), 'DMY') + ""
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Employee name', 'Employee ID', 'Email', 'Branch', 'Shift', 'Work location', 'Last login time'],
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' },
          bgColor: { argb: 'FF0000FF' }
        },
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      }
      customizedData.push(headerRow);

      customizedData.push(...data);

      if (this.excelData['Employee_App_Report'] == undefined) { this.excelData['Employee_App_Report'] = {}; }

      this.excelData['Employee_App_Report'] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 15 }, { colNo: 4, width: 25 }, { colNo: 5, width: 10 },{ colNo: 6, width: 10 },{ colNo: 7, width: 15 },{ colNo: 8, width: 30 }]
        }
      };// excelInfo;

      this.downloadExlReport();

    }

  }

  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Employee_App_Report.xlsx');
  }

}